import { render } from "./B2bTableProfiles.vue?vue&type=template&id=67687086&scoped=true&lang=pug"
import script from "./B2bTableProfiles.vue?vue&type=script&lang=js"
export * from "./B2bTableProfiles.vue?vue&type=script&lang=js"

import "./B2bTableProfiles.vue?vue&type=style&index=0&id=67687086&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67687086"]])

export default __exports__